import { onScopeDispose, ref, watch, type Ref } from 'vue';

const GRADE_COLLAPSE_DELAY_MS = 600;

/** Presentation only: suspend collapse while editing or using the modifier popup. */
export const useSchoolGradeCollapse = (value: Readonly<Ref<number | null>>, editing: Readonly<Ref<boolean>>) => {
  const collapsed = ref(value.value != null);
  const animateScale = ref(true);
  const modifierOpen = ref(false);
  let timer: ReturnType<typeof setTimeout> | undefined;
  const stop = (): void => {
    clearTimeout(timer);
  };
  const schedule = (): void => {
    stop();
    if (value.value == null) collapsed.value = false;
    if (value.value == null || editing.value || modifierOpen.value) return;
    timer = setTimeout(() => {
      collapsed.value = true;
    }, GRADE_COLLAPSE_DELAY_MS);
  };
  watch(value, schedule);
  watch(
    [collapsed, value],
    ([isCollapsed], [wasCollapsed]) => {
      // Replace an already-collapsed grade in place, including collective updates.
      animateScale.value = !isCollapsed || !wasCollapsed;
    },
    { flush: 'sync' },
  );
  watch(modifierOpen, (open) => {
    if (open) stop();
    else schedule();
  });
  onScopeDispose(stop);
  return { collapsed, animateScale, modifierOpen, stop, schedule };
};
